export default __webpack_public_path__ + "static/media/cafeshow_throo06.12ba4d1b.png";